import styled from 'styled-components';

export const Feedback = styled.div`
    display: flex;
    .panel {
        > img {
            flex: ${(props) => !props.desktop && '1'};
            margin: 0 auto;
            width: ${(props) => (props.desktop ? '120px' : '95px')};
            height: ${(props) => (props.desktop ? '120px' : '95px')};
        }
    }
`;

export const FeedbackFace = styled.div`
    img {
        width: ${(props) => (props.desktop ? '72px' : '50px')};
        height: ${(props) => (props.desktop ? '72px' : '50px')};
    }
    p {
        font-size: ${(props) => !props.desktop && '12px'};
    }
    && {
        button:disabled {
            background: none;
            padding: 0;
            display: inline-block;
            position: relative;
        }
        button:disabled::after {
            position: absolute;
            content: '';
            display: block;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(255, 255, 255, 0.5);
        }
    }
`;
